import { render, staticRenderFns } from "./ListaDossier.vue?vue&type=template&id=108d94e0&"
import script from "./ListaDossier.vue?vue&type=script&lang=js&"
export * from "./ListaDossier.vue?vue&type=script&lang=js&"
import style0 from "./ListaDossier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports